// src/common/Datetime24Picker.js
import React, { useEffect, useState } from 'react';
import { styled  } from '@mui/material/styles';
import { LocalizationProvider, DateTimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import 'dayjs/locale/ko';
import ValueMisc from '../value/ValueMisc';

const ThePicker = styled(DateTimePicker)({
    "& .MuiInputBase-input": {padding:"11px 0px 11px 8px", width:115, fontSize:'0.9rem'}
});

export default function Datetime24Picker({
    dict, //label, id,
    value,
    onChange,
    label,
    minDate,
    maxDate,
}) {
    const [defaultValue, setDefaultValue] = useState(dayjs(ValueMisc.getYmdHms(new Date())));
    const id = dict.id;
    const controlLabel = label || dict.label;

    useEffect(()=>{
            if(value) {
                setDefaultValue(dayjs(value));
            }
            else setDefaultValue(dayjs(dayjs(ValueMisc.getYmdHms(new Date(), 5*3600))));
    }, [value]);

    const onChangeDateTime = (value, ctxt) => {
        if(onChange)
            onChange(id, ValueMisc.getYmdHms(value.toDate()));
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
            <ThePicker ampm={false} format='YYYY-MM-DD HH:mm'
                onChange={onChangeDateTime}
                value={defaultValue || ''}
                label={controlLabel}
                minDate={dayjs(minDate || dict.minDate || '2002-01-01')}
                maxDate={dayjs(maxDate || dict.maxDate || '2053-12-31')}
            />
        </LocalizationProvider>
    );
}